import { graphql } from "@server/gql";

export const createCartMutation = graphql(/* GraphQL */ `
  mutation createCart($locale: String!, $items: [CartItemInput!]!) {
    cart: createCart(locale: $locale, items: $items) {
      ...cart
    }
  }
`);
